module.exports = __webpack_public_path__ + "img/check_secondary.c24b7659.png";